var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"newrow",staticStyle:{"padding":"12px"},on:{"click":function($event){return _vm.click($event)}}},[_vm._v("Klicka för att lägga till en ny vara")])
}
var staticRenderFns = []

export { render, staticRenderFns }